<template>
	<CDialog
		class="cog-referral-details-dialog"
		:visible="showDialog"
		title="Referral Program Details"
		custom-class="dialog--narrow"
		@close="handleClose"
	>
		<div>
			<ul class="instructions content list-style">
				<li>
					Your organization's account balance will be credited 20% of the amount paid by the referred organization on any paid subscription, starting on the first of the month after the referred organization has signed up for a paid plan for a maxiumum of twelve months.
				</li>

				<li>
					Referrals expire after one year. If a referred organization signs up for a paid plan more than one year after the referral date, no referral credit will be provided.
				</li>
				<li>
					No referral credit will be given to any organization that is not a Cognito Forms customer at the time of the referral.
				</li>
				<li>
					No referral credit will be given for referring an organization that has already been referred to us, or is an existing Cognito Forms customer.
				</li>
				<li>
					A maximum of one organization will be awarded referral credit for each new customer referred.
				</li>
				<li>
					The referred new customer must purchase at least one Cognito Forms paid subscription and be in good standing for at least 30 days after the purchase prior to issuing the award.
				</li>
				<li>
					Referral credits will automatically be applied in the form of credit to the organization's monthly invoice.
				</li>
				<li>
					Cognito Forms makes the final decision regarding the referral program awards, and reserves the right to change or end the referral program at any time.
				</li>
			</ul>
		</div>
	</CDialog>
</template>

<script lang="ts">
	import CDialog from 'src/components/dialogs/Dialog.vue';
	import { defineComponent } from 'vue';

	export default defineComponent({
		name: 'CReferralProgramDetailsDialog',
		components: {
			CDialog
		},
		props: {
			showDialog: {
				type: Boolean,
				required: true
			}
		},
		methods: {
			handleClose() {
				this.$emit('close');
			}
		}
	});
</script>